import { createSlice } from '@reduxjs/toolkit';

import { savePhone, signIn, signUp, verifyEmail, verifyPhone } from '../actions/auth';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    error: null,
    loading: false
  },
  extraReducers: builder =>
    builder
      // Sign In
      .addCase(signIn.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Sign Up
      .addCase(signUp.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signUp.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(signUp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Email Verification with OTP
      .addCase(verifyEmail.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyEmail.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(verifyEmail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Save phone
      .addCase(savePhone.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePhone.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(savePhone.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Verify phone
      .addCase(verifyPhone.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyPhone.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(verifyPhone.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
});

export default authSlice.reducer;
